import React, { useState } from 'react';
import { Building2, ClipboardList, ShieldAlert } from 'lucide-react';
import OrganizationsManager from './OrganizationsManager';
import OrgSpecialRequestTemplatesManager from './OrgSpecialRequestTemplatesManager';
import AdminOrgSpecialRequestsManager from './AdminOrgSpecialRequestsManager';

/**
 * OrgAdminArea — the Organizations admin tab. The admin sidebar census
 * is owner-frozen (no new sidebar ids), so the Organization Special
 * Requests surfaces live here behind an in-page tab bar, the same
 * pattern the Jobs area uses (one sidebar entry, in-page tabs).
 */
export default function OrgAdminArea({ canEdit = true }: { canEdit?: boolean }) {
  const [view, setView] = useState<'organizations' | 'special-requests' | 'templates'>('organizations');

  const tabBtn = (active: boolean) =>
    `flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium cursor-pointer ${
      active ? 'bg-brand-primary text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'
    }`;

  return (
    <div>
      <div className="flex items-center gap-2 px-6 pt-5">
        <button className={tabBtn(view === 'organizations')} onClick={() => setView('organizations')}>
          <Building2 size={15} /> Organizations
        </button>
        <button className={tabBtn(view === 'special-requests')} onClick={() => setView('special-requests')}>
          <ShieldAlert size={15} /> Special Requests
        </button>
        <button className={tabBtn(view === 'templates')} onClick={() => setView('templates')}>
          <ClipboardList size={15} /> Request Templates
        </button>
      </div>
      {view === 'organizations' && <OrganizationsManager canEdit={canEdit} />}
      {view === 'special-requests' && (
        <AdminOrgSpecialRequestsManager canEdit={canEdit} onOpenTemplates={() => setView('templates')} />
      )}
      {view === 'templates' && <OrgSpecialRequestTemplatesManager canEdit={canEdit} />}
    </div>
  );
}
